export const useIsAnyFilterSet = (store, filtersToCheck) => {
  return filtersToCheck.some(filterName => {
    const filterValue = store.state[filterName];
    if (Array.isArray(filterValue)) {
      return filterValue.length > 0;
    }
    return filterValue !== null && filterValue !== undefined && filterValue !== '';
  });
};